import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MockupPreviewComponent } from '../mockup-preview/mockup-preview.component';
import { PhotosService } from '../services/photos.service';

@Component({
    selector: 'app-instagram-story',
    templateUrl: './instagram-story.component.html',
    styleUrls: ['./instagram-story.component.css']
})
export class InstagramStoryComponent implements OnInit {

    instagramStory = [];

    constructor(private photos: PhotosService, public dialog: MatDialog) { }

    ngOnInit() {
        this.instagramStory = this.photos.instagramStory;
    }

    openDialog(url: string): void {
        if (screen.width > 600) {
            this.dialog.open(MockupPreviewComponent, {
                maxHeight: '90%',
                width: '450px',
                data: {url: url}
            });
        }
    }

}
